import BaseTextEntityUi from './ui/BaseTextEntityUi'

export default BaseTextEntityUi
